import {
  type AccountListLastMonth,
  type AccountReport,
  type AccountReportCategory,
  type AccountReportLastMonth
} from '@/shared/types/osi/accountReports';

interface OsiInfo {
  name: string;
  idn: string;
  unionTypeId: number | null;
}

export interface AccountReportsModule {
  allReports: AccountReport[] | null;
  lastMonthReport: AccountReportLastMonth | null;
  categories: AccountReportCategory[] | null;
  isLoading: boolean;
  readonly accounts: AccountListLastMonth[];
  readonly osiInfo: OsiInfo;
  loadCategoriesCatalog: () => Promise<void>;
  // Дозагружает каталог категорий, если он ещё не загружен (categories === null)
  ensureCategoriesLoaded: () => void;
  loadReports: () => Promise<void>;
  loadAllReports: () => Promise<void>;
  loadLastMonthReport: () => Promise<void>;
  loadListById: (listId: number) => Promise<any>;
  updateLastReportData: () => Promise<void>;
  // Сброс полей к initial + очистка persist сессии (иначе отчёт прошлого месяца протекает между входами)
  clearSession: () => Promise<void>;
}

export const AccountReportsModuleIdentifier = Symbol.for('AccountReportsModule');
